/**
 * An `Error` that carries the code which `social_login_failed` reports.
 *
 * The Apple SDK rejects with a plain `{ error }` object. The caller reads the
 * provider code from that shape. Internal failures reject with a real `Error`,
 * so the code goes on the error.
 */
const providerError = (code: string, message: string) =>
  Object.assign(new Error(message), { error: code });

export { providerError };
